import { Col, Row, Modal, Form, Input } from "antd";
import { useTranslation } from "react-i18next";
import Title from "../../../UI/Title/Title";
import { Dispatch, SetStateAction } from "react";

type propsType = {
  isOpenCrediCard: boolean;
  setIsOpenCreditCard: Dispatch<SetStateAction<boolean>>;
  handlePay: () => Promise<void>
};
export const CreditCard = ({
  isOpenCrediCard,
  setIsOpenCreditCard,
  handlePay
}: propsType) => {
  const [t] = useTranslation("common");
  return (
    <>
      <Modal
        closable={false}
        maskClosable={false}
        centered
        open={isOpenCrediCard}
        onCancel={() => setIsOpenCreditCard(false)}
        cancelText={t("cancel")}
        okButtonProps={{
          style: {
            height: "40px",
            width: "100px",
            background: "#1677FF",
            color: "#fff",
          },
        }}
        cancelButtonProps={{
          style: {
            color: "#1677FF",
            border: "1px solid #1677FF",
            height: "40px",
            width: "100px",
          },
        }}
        okText={`${t("next")}`}
      >
        <Col offset={1}>
          {" "}
          <Title title={`${t("credit-card")}`} />
        </Col>
        <Col offset={1} span={23} className="modaltitleEdit">
          {t("swip-card-or-enter-serial-number")}
        </Col>
        <Form layout="vertical">
          <Row>
            <Col offset={1} span={14} style={{ marginTop: "20px" }}>
              <Form.Item label={`${t("serial-number")}`}>
                <Input placeholder={`${t("enter-text")}`} />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    </>
  );
};
